import React from 'react';
import TemplateOne from 'gatsby-matrix-theme/src/components/molecules/header/variants/slot/template-one';

export default (props) => {
  const { page } = props;

  return <TemplateOne {...props} showExtraRatings />;
};
